module.exports = "/static/Images/images/logo-default-hs.png";